import joinPath from 'path.join'
import { api } from '@/api'
import { createLink } from '@/api/helpers'
import AnnotationLayer from '../annotation_layer'

export default {
  async fetchAnnotationLayers() {
    const annotaionLayerUri = joinPath('versionable', this.version_id.toString(), 'annotation_layers')
    const path = createLink(annotaionLayerUri)
    const { data } = await api.get(path)
    AnnotationLayer.insertOrUpdate({ data })
  },
}
